exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{background-color:#faf8f0;background-image:url(" + require("../images/bgs/BG-halftone.png") + ");background-repeat:repeat}section{clear:both}.hero{min-height:500px;background-image:url(" + require("../images/albumy/priestory/exterier_F21.jpg") + ")}#gallery-wrapper>div{float:left;max-height:85px}#gallery-wrapper .portfolio-title{padding:0}.small-gallery-wrapper{bottom:-85px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./app/css/style-my.css
 ** module id = 16
 ** module chunks = 0
 **/